import {GETTING_CONTENT_DATA,
    GETTING_CONTENT_DATA_SUCCESS,
    GETTING_CONTENT_DATA_FAILED,
    
  } from '../Constants/HomepageHeaderConstant'

const initialState = {
	gettingContentData: false,
	contentData: null,
	gettingContentDataFailed: false,
};

export default function HomepageHeaderReducer(state = initialState, action) {
	switch (action.type) {
	
		case GETTING_CONTENT_DATA:
			return {
				...state,
				gettingContentData: true,
				contentData: null,
				gettingContentDataFailed: false,
			};

		case GETTING_CONTENT_DATA_SUCCESS:
			return {
				...state,
				gettingContentData: false,
				contentData: action.payload,
				gettingContentDataFailed: false,
			};

		case GETTING_CONTENT_DATA_FAILED:
			return {
				...state,
				gettingContentData: false,
				contentData: null,
				gettingContentDataFailed: false,
			};

		default:
			return state;
	}
}

